module.exports = __webpack_public_path__ + "static/img/yamamoto_02.ad6685c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/yamamoto_02.jpg
// module id = jpPI
// module chunks = 0